import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";
import { SubscriptionTypeEnum } from "../../organisation/models/subscription";
import { OrderDto, OrderListDto } from "../models/order";

@Injectable({
  providedIn: "root",
})
export class OrderService extends BaseService<OrderDto, OrderListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "order");
  }

  getForRenewSubscription(type: SubscriptionTypeEnum): Observable<OrderDto> {
    return this.get("/renewSubscription/" + type);
  }
  pay(order: OrderDto): Observable<string> {
    return this.post<OrderDto, string>("/pay", order);
  }
}
